import { AppState } from "../reducers";

export const selectContactLoading = (state: AppState) => state.contactReducer.loading;
export const selectContactSubmitLoading = (state: AppState) => state.contactReducer.loadingSubmit;
export const selectContactForm = (state: AppState) => state.contactReducer.contactForm;